import { ref, onMounted, onBeforeUnmount } from 'vue'
export function polling(
    fetchAll,
    {
        oldData = [],
        intervalMs = 6000,
        isDifferent = (newData) => { return JSON.stringify(oldData) !== JSON.stringify(newData) },
        runOnStart = true,
        onChange = () => {},
    } = {}
){
    const intervalId = ref(null)
    const poll = async () => {
        try {
            const allNewData = await fetchAll()
            if (isDifferent(allNewData)) {
                onChange(allNewData)
            }
        } catch (err) {
            console.error('Polling error:', err)
        }
    }
    const startPolling = () => {
        stopPolling()
        intervalId.value = setInterval(() => {
            poll()
        }, intervalMs)
    }
    const stopPolling = () => {
        if (intervalId.value) {
            clearInterval(intervalId.value)
            intervalId.value = null
        }
    }
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            if (runOnStart) poll()
            startPolling()
        } else {
            stopPolling()
        }
    }
    onMounted(() => {
        if (runOnStart) poll()
        startPolling()
        document.addEventListener('visibilitychange', handleVisibilityChange)
    })
    onBeforeUnmount(() => {
        stopPolling()
        document.removeEventListener('visibilitychange', handleVisibilityChange)
    })
    return {
        startPolling,
        stopPolling,
    }
}